/**
 * 句子导航组件
 * 显示所有句子的进度点，支持点击跳转
 */
import React, { useEffect, useRef } from 'react';
import { SubtitleSegment, ShadowProgress } from '../../../db/shadowDb';

interface SentenceNavProps {
  /** 所有字幕 */
  subtitles: SubtitleSegment[];
  /** 当前句子索引 */
  currentIndex: number;
  /** 练习进度 */
  progress: ShadowProgress;
  /** 跳转到指定句子 */
  onNavigate: (index: number) => void;
}

export function SentenceNav({
  subtitles,
  currentIndex,
  progress,
  onNavigate,
}: SentenceNavProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const currentDotRef = useRef<HTMLButtonElement>(null);

  // 自动滚动到当前句子
  useEffect(() => {
    if (currentDotRef.current && containerRef.current) {
      const container = containerRef.current;
      const dot = currentDotRef.current;

      const containerRect = container.getBoundingClientRect();
      const dotRect = dot.getBoundingClientRect();

      // 如果当前点不在可视区域内，滚动到它
      if (dotRect.left < containerRect.left || dotRect.right > containerRect.right) {
        dot.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center',
        });
      }
    }
  }, [currentIndex]);

  return (
    <div className="sentence-nav" ref={containerRef}>
      {subtitles.map((_, index) => {
        const isCurrent = index === currentIndex;
        const isPracticed = progress.practicedSentences.includes(index);

        return (
          <button
            key={index}
            ref={isCurrent ? currentDotRef : undefined}
            type="button"
            className={`sentence-dot ${isCurrent ? 'current' : ''} ${isPracticed ? 'practiced' : ''}`}
            onClick={() => onNavigate(index)}
            title={`句子 ${index + 1}`}
          >
            {index + 1}
          </button>
        );
      })}
    </div>
  );
}
